import { render, staticRenderFns } from "./TestCases.vue?vue&type=template&id=7c5d6cce&scoped=true&"
import script from "./TestCases.vue?vue&type=script&lang=js&"
export * from "./TestCases.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7c5d6cce",
  null
  
)

export default component.exports